import { useTranslation } from "react-i18next";

import { DMS_WARNING_SOURCES } from "models";

const sourceLabelMap: Record<DMS_WARNING_SOURCES, string> = {
  [DMS_WARNING_SOURCES.Client]: "Client",
  [DMS_WARNING_SOURCES.Server]: "Server",
  [DMS_WARNING_SOURCES.CustomQuery]: "Custom_Query"
};

type SourceLabelProps = {
  source: DMS_WARNING_SOURCES;
};

export const SourceLabel = ({ source }: SourceLabelProps) => {
  const { t } = useTranslation();

  return t(`v8_${sourceLabelMap[source].toLowerCase().replace(" ", "_")}`, sourceLabelMap[source]);
};
